<template>
  <div class="resource-nav">
    <div class="resource-nav-row" :style="{ paddingLeft }">
      <i
        v-if="showToggle"
        class="dropdown icon resource-nav-toggle"
        :class="{ rotated: !expanded }"
        v-on:click="toggle()"
      ></i>
      <i v-else-if="depth > 0" class="resource-nav-toggle-spacer"></i>

      <router-link
        v-if="node.to && !node.note"
        :to="node.to"
        class="resource-nav-link"
      >
        <i v-if="iconClass" :class="iconClass"></i>{{ node.title }}
      </router-link>
      <a
        v-else-if="node.href"
        :href="node.href"
        target="_blank"
        rel="noopener"
        class="resource-nav-link"
      >
        <i :class="iconClass || 'external alternate icon'"></i>{{ node.title }}
      </a>
      <span v-else class="resource-nav-link is-note">
        {{ node.title }}
        <span v-if="node.note" class="ui mini label">{{ node.note }}</span>
      </span>
    </div>

    <div v-if="hasChildren && expanded" class="resource-nav-children">
      <resource-nav
        v-for="child in node.children"
        :key="child.key"
        :node="child"
        :depth="depth + 1"
      />
    </div>
  </div>
</template>

<script>
// Recursive, expandable navigation for the Resources area.
// Content comes from src/data/resources.js. The top level (depth 0) is always shown
// and cannot be collapsed; deeper levels start collapsed and expand on demand or when
// the current route falls inside them.
export default {
  name: 'ResourceNav',
  props: {
    node: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // null => follow the default / active-path rule, true/false => user choice
      manualOpen: null,
    };
  },
  computed: {
    hasChildren() {
      return Array.isArray(this.node.children) && this.node.children.length > 0;
    },
    showToggle() {
      return this.hasChildren && this.depth > 0;
    },
    paddingLeft() {
      return this.depth === 0 ? '1.15em' : `${0.6 + this.depth}em`;
    },
    onActivePath() {
      if (!this.node.to) {
        return false;
      }
      const path = this.$route.path;
      return path === this.node.to || path.startsWith(`${this.node.to}/`);
    },
    expanded() {
      if (this.depth === 0) {
        return true;
      }
      if (this.manualOpen !== null) {
        return this.manualOpen;
      }
      return this.onActivePath;
    },
    iconClass() {
      if (!this.node.icon) {
        return '';
      }
      const color = this.node.iconColor ? `${this.node.iconColor} ` : '';
      return `${color}${this.node.icon} icon`;
    },
  },
  watch: {
    // Re-open when navigation moves onto this node's subtree.
    onActivePath(active) {
      if (active) {
        this.manualOpen = null;
      }
    },
  },
  methods: {
    toggle() {
      this.manualOpen = !this.expanded;
    },
  },
};
</script>

<style scoped>
.resource-nav-row {
  display: flex;
  align-items: baseline;
  padding-right: 0.5em;
}

.resource-nav-toggle {
  cursor: pointer;
  color: #999;
  margin: 0;
  width: 1em;
  flex: 0 0 1em;
}

.resource-nav-toggle.rotated {
  transform: rotate(-90deg);
}

.resource-nav-toggle-spacer {
  flex: 0 0 1em;
  width: 1em;
}

.resource-nav-link {
  display: block;
  padding: 0.5em 0;
  color: #337ab7;
  flex: 1 1 auto;
  line-height: 1.3;
}

.resource-nav-link.router-link-exact-active {
  font-weight: 700;
}

.resource-nav-link.is-note {
  color: #999;
}

.resource-nav-link i.icon {
  margin-right: 0.5em;
  float: none;
}
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourceNav.vue